import React from 'react';
import PropTypes from 'prop-types';
import InformationBubble from 'Components/information-bubble/InformationBubble';

import Button from 'Components/Button';

const NumberedRoundButton = ({
  children,
  tooltipTitle,
  ...props
}) => {
  return (
    <div style={{padding:"5px 0"}}> 

      <InformationBubble
        tooltipContent={tooltipTitle}
        id={tooltipTitle}
      >
        <Button
          category="numbered-round"
          {...props}
        >
          {children}
        </Button>
      </InformationBubble>
    </div>
  );
};

NumberedRoundButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  tooltipTitle: PropTypes.string,
};

export default NumberedRoundButton;
